var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoactiveimage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 374,
    viewBox: "0 0 357 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2623_25152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.273 35.5063H73.5557L93.9215 340.91H309.681L289.273 35.5063Z",
    fill: "#A8BFE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5399 35.5067H289.144L264.432 340.91H2.82812L27.5399 35.5067Z",
    fill: "#D3DFF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.136 109.77H21.5322L27.5397 35.5067H289.144L283.136 109.77Z",
    fill: "#7CA0D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.108 80.8823C113.223 80.8823 119.017 75.0451 119.017 67.9299C119.017 60.8146 113.223 54.9775 106.108 54.9775C98.9498 54.9775 93.1553 60.8146 93.1553 67.9299C93.1553 75.0452 98.9498 80.8823 106.108 80.8823Z",
    fill: "#FEFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.999 5C117.44 5 127.624 15.183 127.624 27.6241V35.2507H121.957V28.8597C121.957 19.5715 114.33 11.9449 104.999 11.9449C95.6686 11.9449 88.0847 19.5715 88.0847 28.8597V47.6918C88.0847 56.8948 95.4981 64.4362 104.659 64.6066C108.152 65.8422 106.405 71.2106 104.659 71.5514C92.388 71.3384 82.418 61.2407 82.418 48.9273V27.6241C82.4181 15.183 92.5584 5 104.999 5Z",
    fill: "#E89EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.651 80.8823C207.766 80.8823 213.603 75.0451 213.603 67.9299C213.603 60.8146 207.766 54.9775 200.651 54.9775C193.535 54.9775 187.698 60.8146 187.698 67.9299C187.698 75.0452 193.535 80.8823 200.651 80.8823Z",
    fill: "#FEFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.586 5C211.984 5 222.167 15.183 222.167 27.6241V35.2507H216.501V28.8597C216.501 19.5715 208.874 11.9449 199.586 11.9449C190.255 11.9449 182.629 19.5715 182.629 28.8597V47.6918C182.629 56.8948 190.042 64.4362 199.203 64.6066C202.739 65.8422 200.949 71.2106 199.203 71.5514C186.932 71.3384 176.962 61.2407 176.962 48.9273V27.6241C176.962 15.183 187.145 5 199.586 5Z",
    fill: "#E89EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1436 137.421H79.3917L76.4093 174.361H31.1611L34.1436 137.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5244 137.421H143.772L140.79 174.361H95.542L98.5244 137.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.239 137.421H206.487L203.505 174.361H158.257L161.239 137.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.528 137.421H266.777L263.794 174.361H218.546L221.528 137.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0313 198.561H74.2794L71.2969 235.501H26.0488L29.0313 198.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4102 198.562H138.658L135.676 235.501H90.4277L93.4102 198.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.126 198.562H201.374L198.392 235.501H153.144L156.126 198.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.414 198.562H261.662L258.68 235.501H213.432L216.414 198.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1329 260.085H69.381L66.3985 297.025H21.1504L24.1329 260.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5105 260.085H133.716L130.733 297.025H85.4854L88.5105 260.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.228 260.085H196.476L193.493 297.025H148.245L151.228 260.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.516 260.085H256.764L253.781 297.025H208.533L211.516 260.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.555 142.236C109.046 140.873 111.177 140.873 112.327 142.193C113.648 143.685 114.926 145.133 116.247 146.624C117.525 148.116 118.846 149.607 120.167 151.098C121.828 149.607 123.447 148.073 125.109 146.582C126.771 145.09 128.432 143.557 130.094 142.065C131.585 140.702 133.716 140.702 134.909 142.023C136.102 143.344 135.846 145.559 134.355 146.88C132.693 148.414 131.031 149.905 129.37 151.396C127.708 152.93 126.046 154.421 124.385 155.913C125.706 157.404 127.026 158.895 128.347 160.386C129.668 161.92 130.989 163.411 132.31 164.903C133.46 166.223 133.204 168.439 131.713 169.76C130.264 171.081 128.092 171.081 126.899 169.76C125.578 168.269 124.3 166.777 122.979 165.286C121.658 163.795 120.337 162.261 119.059 160.77C117.397 162.304 115.736 163.795 114.074 165.286C112.455 166.777 110.793 168.269 109.132 169.76C107.683 171.081 105.553 171.081 104.36 169.76C103.209 168.439 103.465 166.266 104.956 164.945C106.575 163.454 108.237 161.963 109.856 160.429C111.518 158.938 113.179 157.446 114.798 155.955C113.52 154.464 112.199 152.973 110.921 151.482C109.6 149.99 108.322 148.542 107.001 147.051C105.851 145.73 106.107 143.557 107.555 142.236Z",
    fill: "#D3DFF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0633 203.333C39.5546 202.012 41.6848 202.012 42.8352 203.333C44.156 204.782 45.4341 206.273 46.7549 207.764C48.0757 209.255 49.3539 210.747 50.6747 212.238C52.3364 210.704 53.998 209.213 55.6171 207.721C57.2787 206.23 58.9404 204.696 60.6021 203.205C62.0933 201.842 64.2237 201.842 65.4166 203.163C66.6095 204.483 66.3539 206.699 64.8627 208.02C63.201 209.511 61.5394 211.045 59.8777 212.536C58.2162 214.027 56.5545 215.561 54.9354 217.052C56.2136 218.544 57.5344 220.035 58.8552 221.526C60.176 223.017 61.4968 224.551 62.8176 226.042C63.9681 227.363 63.7123 229.536 62.2637 230.899C60.7725 232.22 58.5996 232.22 57.4066 230.899C56.1283 229.408 54.8075 227.917 53.4867 226.383C52.1659 224.892 50.8878 223.401 49.567 221.91C47.9053 223.401 46.2437 224.934 44.6247 226.426C42.963 227.917 41.3013 229.408 39.6823 230.899C38.191 232.22 36.0607 232.22 34.9103 230.899C33.7599 229.579 33.9729 227.406 35.4641 226.085C37.0832 224.551 38.7449 223.06 40.3639 221.569C42.0256 220.077 43.6873 218.586 45.3489 217.095C44.0281 215.604 42.7073 214.113 41.4291 212.621C40.1083 211.13 38.8301 209.639 37.5094 208.19C36.359 206.869 36.6146 204.696 38.0633 203.333Z",
    fill: "#E89EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5426 264.857C98.9913 263.537 101.122 263.537 102.315 264.857C103.593 266.306 104.914 267.797 106.192 269.289C107.513 270.78 108.833 272.271 110.112 273.762C111.773 272.271 113.435 270.737 115.097 269.246C116.758 267.755 118.377 266.221 120.039 264.73C121.53 263.366 123.703 263.366 124.853 264.687C126.046 266.008 125.791 268.223 124.3 269.544C122.638 271.035 120.976 272.569 119.315 274.06C117.696 275.552 116.034 277.086 114.372 278.577C115.693 280.068 116.971 281.559 118.292 283.05C119.613 284.542 120.934 286.075 122.255 287.567C123.447 288.888 123.192 291.06 121.701 292.424C120.209 293.745 118.036 293.745 116.886 292.424C115.565 290.933 114.245 289.441 112.924 287.908C111.645 286.416 110.325 284.925 109.004 283.434C107.342 284.925 105.723 286.459 104.061 287.95C102.4 289.441 100.781 290.933 99.1191 292.424C97.6705 293.745 95.4975 293.745 94.3472 292.424C93.1968 291.103 93.4525 288.93 94.9011 287.609C96.5627 286.118 98.1818 284.584 99.8435 283.093C101.463 281.602 103.124 280.111 104.786 278.619C103.465 277.128 102.187 275.637 100.866 274.146C99.5878 272.654 98.267 271.163 96.9888 269.715C95.8384 268.394 96.094 266.221 97.5426 264.857Z",
    fill: "#E89EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.813 208.872L247.943 202.949L243.129 201.373C242.319 199.157 243.385 196.047 240.658 194.684C238.144 194.854 241.297 198.561 240.615 200.606C236.568 200.137 235.204 195.28 231.966 196.43C227.876 197.709 226.086 202.012 230.262 204.27C233.457 205.676 235.928 205.463 238.613 205.591L245.813 208.872Z",
    fill: "#FCC0A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.694 350.965L281.518 352.499C276.321 355.694 263.666 354.544 265.967 362L290.423 361.403C290.381 358.378 290.551 355.14 288.889 352.286L285.694 350.965Z",
    fill: "#0A0A0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.932 348.153L281.476 348.409L281.518 352.499C284.032 353.223 286.588 353.095 288.889 352.286L288.932 348.153Z",
    fill: "#FCC0A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.277 349.133L323.23 351.05C318.373 354.714 305.676 354.799 308.658 362L332.944 359.017C332.603 356.035 332.475 352.797 330.558 350.113L327.277 349.133Z",
    fill: "#0A0A0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.174 346.022L322.803 346.96L323.229 351.05C325.785 351.519 328.342 351.135 330.557 350.113L330.174 346.022Z",
    fill: "#FCC0A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.146 231.709L323.442 245.769L322.931 297.28L332.219 346.15L320.715 347.428L305.718 298.729L303.758 273.719L295.79 301.072L290.038 350.283L280.324 350.07L279.855 301.925L290.209 244.874L296.216 237.461L306.059 241.636L308.146 231.709Z",
    fill: "#1BA49D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.315 184.842C334.392 191.659 345.726 201.33 355.184 209.809C356.505 211.343 356.377 212.749 355.525 213.942L330.387 243.809L325.019 237.972L340.23 215.476L326.34 209.809L323.443 245.769C311.811 254.759 301.543 244.235 290.21 244.874L288.548 206.614L280.836 219.523C278.919 222.421 275.851 220.631 272.783 219.523L242.831 208.872L244.621 200.99C254.164 203.162 263.538 206.741 273.082 208.872C276.448 200.819 277.598 189.23 285.012 186.035C292.084 183.137 314.836 180.325 323.315 184.842Z",
    fill: "#DC4262"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.936 153.015C122.084 154.591 122.68 156.551 124.256 157.361L134.226 162.729C135.803 163.539 137.763 162.985 138.572 161.408C139.424 159.832 138.828 157.872 137.294 157.063L127.282 151.694C125.705 150.885 123.745 151.438 122.936 153.015Z",
    fill: "#E89EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.076 178.622L167.758 177.003L168.738 175.511L168.44 175.384L173.297 164.008L169.675 162.09L131.926 154.166L130.477 157.063L128.858 159.832L156.425 186.887L160.004 188.805L166.778 178.494L167.076 178.622Z",
    fill: "#E07D8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.107 244.065C289.486 250.882 292.085 259.489 298.902 263.11L313.899 271.163C320.759 274.784 329.323 272.185 332.944 265.368C336.608 258.551 334.009 249.987 327.192 246.323L312.195 238.313C305.335 234.649 296.771 237.248 293.107 244.065Z",
    fill: "#E07D8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.987 164.817L166.693 171.889L159.663 172.656L162.901 178.962L154.977 179.814L158.641 186.929L156.809 187.1L308.743 268.393L322.037 243.553L170.059 162.303L170.954 163.964L162.987 164.817Z",
    fill: "#E89EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.697 239.615L301.405 264.455L308.733 268.376L322.025 243.536L314.697 239.615Z",
    fill: "#D3DFF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.104 239.506C323.656 240.955 318.671 239.591 318.884 241.168C319.224 242.702 322.803 241.935 322.889 242.531C323.826 244.747 318.074 248.07 319.054 249.774C321.397 253.865 327.575 250.414 329.62 243.469L325.573 239.038C325.445 239.165 325.275 239.336 325.104 239.506Z",
    fill: "#FCC0A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36 173.314L310.91 184.623C310.91 184.623 308.01 186.943 303.805 186.653C299.601 186.363 296.991 183.753 296.991 183.753L298.731 169.255L312.36 173.314Z",
    fill: "#FC9A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.89 149.203C312.926 150.278 318.089 155.597 314.491 167.558C310.894 179.52 304.309 180.231 298.611 178.958C292.914 177.686 291.209 176.9 292.507 165.53C293.611 155.868 293.973 147.381 305.89 149.203Z",
    fill: "#FCC0A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.309 158.314C320.746 161.518 320.689 164.768 318.715 167.037C316.742 169.306 315.001 175.824 312.891 175.686C310.781 175.549 312.576 161.914 312.576 161.914L320.309 158.314Z",
    fill: "#0A0A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.221 153.091C293.221 153.091 295.04 157.36 300.068 155.518C305.096 153.676 300.996 159.707 305.192 158.533C309.387 157.358 308.177 162.538 306.421 167.747C308.936 168.454 308.587 168.65 308.587 168.65L310.833 163.109C310.833 163.109 320.512 163.805 320.243 160.092C319.974 156.379 323.297 151.122 319.552 149.809C315.807 148.495 314.844 142.523 309.739 143.214C304.635 143.905 302.843 140.019 297.405 142.357C291.967 144.695 285.773 144.374 293.221 153.091Z",
    fill: "#0A0A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.848 163.084C318.69 158.145 313.209 174.37 308.012 170.446L310.848 163.084Z",
    fill: "#FCC0A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2623_25152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 373,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoactiveimage);
export default __webpack_public_path__ + "static/media/noactiveimage.9ba216a2b32a1a74274d41323c579649.svg";
export { ForwardRef as ReactComponent };